import { useEffect, useState } from "react";
import Cross from "../../../assets/icons/Cross";
import DefaultButton from "../../default-button/DefaultButton";
import ArrowLeft from "../../../assets/icons/ArrowLeft";
import Rename from "../../../assets/icons/Rename";
import Tick from "../../../assets/icons/Tick";
import { Category, Item } from "../../../misc/types";
import { useHookstate } from "@hookstate/core";
import InputField from "../../input-field/InputField";
import { onInputChangeNative, showSnackbar, updateMiscState } from "../../../misc/utils";
import { useGlobalMiscState } from "../../../stores/misc";
import { simpleGetter } from "../../../actions/common";
import { socialTranscriptApi } from "../../../api/api";

type SocialSubcategoryCreateBody = {
  name: string;
  description: string;
  points: string;
  social_category_id: number;
  id?: number;
}

export default function AddItemModal() {
  const miscState = useGlobalMiscState();
  const socialTranscriptCurrentCategory = miscState.get('socialTranscriptCurrentCategory');
  const socialTranscriptCurrentSubcategory = miscState.get('socialTranscriptCurrentSubcategory');
  const localState = useHookstate({});
  const state: Record<string, any> = localState.get();
  const name = state.name || "";
  const description = state.description || "";
  const points = state.points || "";

  useEffect(() => {
    if (socialTranscriptCurrentSubcategory?.name) {
      localState.merge({
        name: socialTranscriptCurrentSubcategory.name,
        description: socialTranscriptCurrentSubcategory.description,
        points: socialTranscriptCurrentSubcategory.points,
      })
    }
  }, [socialTranscriptCurrentSubcategory?.name])

  const onClose = () => {
    updateMiscState('socialTranscriptIsAddSubcategoryModalOpen')(false)
  }

  const submit = async () => {
    const body: SocialSubcategoryCreateBody = {
      name,
      description,
      points,
      social_category_id: socialTranscriptCurrentCategory.id
    };
    if (socialTranscriptCurrentSubcategory) {
      body.id = socialTranscriptCurrentSubcategory.id
    }
    const response = await simpleGetter(socialTranscriptApi.createSubcategory, body)
    showSnackbar(response.success ? 'Успешно' : 'Произошла ошибка', response.success ? 'success' : 'error')
    if (response.success) {
      miscState.setBatch({
        socialTranscriptIsAddSubcategoryModalOpen: false,
        socialTranscriptTriggerFetch: (miscState.get('socialTranscriptTriggerFetch') || 0) + 1
      })
    }
  }

  const validateForm = () => state.name && state.description && state.points

  return (
    <div className="w-fit p-8 rounded-xl bg-white text-black absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col">
      <div>
        <div
          onClick={onClose}
          className="flex justify-end cursor-pointer"
        >
          <Cross additionalStyle="text-[#5F6B88]" />
        </div>
        <p className="font-normal text-[15px] text-[#5F6B88]">
          Добавление пункта в категорию
        </p>

        <p className="text-black font-normal text-[24px]">{socialTranscriptCurrentCategory?.name}</p>
      </div>
      <div className=" mt-8">
        <p className="font-medium text-[15px] text-[#5F6B88]">
          Название пункта
        </p>
        <InputField
          type="text"
          value={name}
          handleChange={onInputChangeNative(localState, 'name')}
          additionalClassName="bg-valley-background-blue py-3 px-4 text-valley-black rounded-lg"
        />
        <p className="mt-6 font-medium text-[15px] text-[#5F6B88]">Описание</p>
        <InputField
          type="textarea"
          value={description}
          handleChange={onInputChangeNative(localState, 'description')}
          additionalClassName="bg-valley-background-blue py-3 px-4 text-valley-black rounded-lg"
        />
        <p className="mt-6 font-medium text-[15px] text-[#5F6B88]">
          Количество баллов
        </p>
        <InputField
          type="number"
          value={points}
          handleChange={onInputChangeNative(localState, 'points')}
          additionalClassName="bg-valley-background-blue py-3 px-4 text-valley-black rounded-lg"
        />
      </div>
      <div className="grid grid-cols-[5fr_7fr] gap-3 mt-4">
        <DefaultButton
          buttonText="Вернуться"
          additionalStyle="bg-[#5F6B88] text-white px-8 py-3 text-nowrap"
          Icon={ArrowLeft}
          onClick={onClose}
        />
        <DefaultButton
          buttonText={socialTranscriptCurrentSubcategory?.id ? "Сохранить" : "Создать пункт"}
          additionalStyle="bg-[#0068FF] text-white px-8 py-3 text-nowrap"
          disabled={!validateForm()}
          Icon={Tick}
          onClick={submit}
        />
      </div>
    </div>
  );
}
